import { createSelector } from '@ngrx/store';
import { getLoyaltyAppSettings } from '../getLoyaltyAppSettings';

export const getLoyaltyAppDataDownloading = createSelector(getLoyaltyAppSettings, (settings) => settings.isDownloading);
